import * as HTTP_REQUEST from "./api";
import { handleResponse } from "../utils/functions";

const PATH_BDPARTICIPANTES = "/mas_participantes";
const PATH_DATA_EXCEL = "/mas_participantes/download";
const PATH_TEMPLATE_EXCEL = "/mas_participantes/plantilla";

export const getAll = async () => {
  const response = await HTTP_REQUEST.get(PATH_BDPARTICIPANTES);
  return handleResponse(response);
};

export const addOne = async (body) => {
  const response = await HTTP_REQUEST.post(PATH_BDPARTICIPANTES, body);
  return handleResponse(response);
};

export const updateOne = async (body, recordId) => {
  const response = await HTTP_REQUEST.put(PATH_BDPARTICIPANTES + "/", body, recordId);
  return handleResponse(response);
};

export const deleteOne = async (recordId) => {
  const response = await HTTP_REQUEST.delt(PATH_BDPARTICIPANTES, recordId);
  return handleResponse(response);
};

// Obtiene el excel file
export const downloadExcelFileBDParticipantes = async () => {
  const response = await HTTP_REQUEST.getFile(PATH_DATA_EXCEL);
  return response; // return a blob
};

// Obtiene el excel platilla
export const downloadExcelPlantillaBDParticipantes = async () => {
  const response = await HTTP_REQUEST.getFile(PATH_TEMPLATE_EXCEL);
  return response; // return a blob
};
